import { render } from "./About.vue?vue&type=template&id=7e43d862"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7e43d862&lang=css"

import exportComponent from "/vercel/path0/Web_Apps/Dorm_Review/WebUI/UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__